// src/components/About/About.jsx
import React, { useEffect } from "react";
import { initAOS } from "../../helpers/aosConfig";
import SectionWrapper from "../SectionWrapper/SectionWrapper";
import heroImg from "../../assets/meistä_image.webp";

const descriptionParagraphs = [
  "Bilebändi Joyride on ammattitaitoinen ja rock-henkinen kokoonpano Keski-Uudeltamaalta. Yhtye tuo energistä livemusiikkia juhliin, häihin ja muihin tapahtumiin.<br /><br />",
  "Joyridessa yhdistyy kokemus ja nuorekas energia: mukana on sekä pitkän linjan bilebändiveteraaneja että musiikkiin kouluttautuneita ammattilaisia. Tämä tekee keikoistamme monipuolisia ja viihdyttäviä.<br /><br />",
  "Ohjelmistomme on laaja ja monipuolinen: mukana on ulkomaisia ja kotimaisia bilehittejä, rock- ja popklassikoita sekä perinteisiä tanssi- ja hääkappaleita – musiikkia siis kaikenikäisille ja kaikkiin tilanteisiin.<br /><br />",
  "Panostamme myös visuaaliseen ilmeeseen: käytämme keikoillamme näyttäviä valoja ja lavaefektejä, jotka luovat näyttävän ja houkuttelevan esiintymisympäristön. Illan kruunaa energinen esiintyminen ja tanssittavat hitit, jotka saavat yleisön viihtymään.<br /><br />",
  "Joyride tunnetaan tilannetajustaan ja kyvystään mukautua yleisön fiiliksiin – jokainen keikka on ainutlaatuinen kokemus, joka nostaa tunnelman kattoon.",
  "Bändin jäsenet huolehtivat myös visuaalisesta ilmeestä ja esiintymisen ammattimaisuudesta. Oli kyseessä mikä tilaisuus tahansa, Joyride sopii siihen varmasti.<br /><br />",
  "Kun etsit monipuolista, näyttävää ja ammattitaitoista bilebändiä, Joyride on varma valinta. Lisäksi esiintymisemme on bilebändien hintaluokassa erittäin kilpailukykyinen."
];

const About = () => {
  useEffect(() => {
    initAOS();
  }, []);

  return (
    <>
      <SectionWrapper id="meista">
        <div className="relative">
          <img
            src={heroImg}
            alt="Bilebändi Joyride instagram promo"
            className="float-left w-64 h-auto rounded-lg shadow-lg mr-6 mb-4"
            data-aos="fade-up"
          />

          <h1
            id="meista-heading"
            className="text-4xl font-bold font-lobster text-joyridePurple dark:text-joyrideCyan mb-6 dark:text-shadow-lg"
            data-aos="fade-up"
          >
            Bilebändi Joyride
          </h1>

          {descriptionParagraphs.map((text, idx) => (
            <p 
              key={idx} 
              className="text-lg font-light text-joyrideNavy dark:text-joyrideLight" 
              data-aos="fade-up"
            >
              {text.split("<br />").map((part, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {part}
                </React.Fragment>
              ))}
            </p>
          ))}
        </div>
      </SectionWrapper>
    </>
  );
};

export default About;
